function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M336.7 381.3h-315c-11.3 0-20.6 9-20.6 20.5s9.5 20.6 20.8 20.6h315c11.4 0 20.6-9 20.6-20.6 0-11.3-9.3-20.5-20.6-20.5zM490.4 223H21.6C10.3 223 1 232.3 1 243.7c0 11.5 9.3 20.6 20.6 20.6h468.8c11.4 0 20.6-9 20.6-20.6 0-11.4-9.2-20.5-20.6-20.5zM21.6 106h468.8c11.4 0 20.6-9 20.6-20.6C511 74 501.8 65 490.4 65H21.6C10.3 65 1 74 1 85.3 1 96.8 10.3 106 21.6 106z"
});

function SvgHamburger(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 512 512",
    preserveAspectRatio: "xMidYMid",
    fill: "currentcolor",
    "data-qa": "svg",
    "aria-labelledby": titleId
  }, props), title ? React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

export default SvgHamburger;